import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const IS_FILTER_HASHTAG = 1;

export default {
    IS_FILTER_HASHTAG,
    getSoap() {
        return Axios.get(`${baseURL}account/template/soap`).then(
            response => response.data.response
        );
    },
    getAllSnippet(filterHastag = 1) {
        return Axios.get(`${baseURL}account/template/snippet`, {
            params: { filter_hashtag: filterHastag ? 1 : 0 }
        }).then(response => response.data.response);
    },
    getBundles(params = {}) {
        return Axios.get(`${baseURL}account/template/bundle`, { params }).then(
            response => response.data.response
        );
    },
    getElementBundle(elementId) {
        return Axios.get(
            `${baseURL}account/template-element/${elementId}`
        ).then(response => {
            if (response.data.response && response.data.response.code == 200) {
                return response.data.response.resources;
            }
            return null;
        });
    },
    getAttachments() {
        return Axios.get(
            process.env.BARRACUDA + "account/template/attachment"
        ).then(function (response) {
            if (
                response.data.response &&
                response.data.response.message.code == 200
            ) {
                return response.data.response.resources;
            }
            return [];
        });
    },
    async get(templateEncodedId, isEncoded = true) {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}account/template/${templateEncodedId}?${
                isEncoded ? "encoded=true" : ""
            }`
        );

        if (res.data && res.data.response && res.data.response.resources) {
            return res.data.response.resources;
        } else {
            return null;
        }
    },
    getTemplates(params) {
        return Axios.get(`${process.env.BARRAMUNDI}account/template`, {
            params
        }).then(response => {
            if (response && response.data && response.data.response) {
                return response.data.response;
            } else {
                return null;
            }
        });
    },
    async duplicate(templateId, params) {
        let res = await Axios.put(
            `${process.env.BARRAMUNDI}account/template/duplicate/${templateId}`,
            params
        );

        if (res.data && res.data.response && res.data.response.resource) {
            return res.data.response.resource;
        } else {
            return null;
        }
    },
    async post(params) {
        let res = await Axios.post(`${baseURL}account/template/save`, params);

        if (res.data && res.data.response && res.data.response.resource) {
            return res.data.response.resource;
        } else {
            return null;
        }
    },
    async getDeleteMessage(templateId) {
        let res = await Axios.post(
            `${baseURL}account/template/confirm/${templateId}`
        );

        if (res.data && res.data.response && res.data.response.resource) {
            return res.data.response.resource;
        } else {
            return null;
        }
    },
    async delete(templateId) {
        let res = await Axios.delete(
            `${process.env.BARRAMUNDI}account/template/${templateId}`
        );
        if (res.data && res.data.response && res.data.response.resource) {
            return res.data.response.resource;
        } else {
            return null;
        }
    },
    async put(templateId, params) {
        let res = await Axios.put(
            `${process.env.BARRAMUNDI}account/template/save/${templateId}`,
            params
        );
        if (res.data && res.data.response && res.data.response.resource) {
            return res.data.response.resource;
        } else {
            return null;
        }
    },
    async getTemplateType() {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}account/template-type-list-options`
        );

        if (res.data && res.data.response && res.data.response.resources) {
            return res.data.response.resources;
        } else {
            return null;
        }
    },
    async checkUsesItems(templateId) {
        let res = await Axios.get(
            `${baseURL}account/template/check-uses-items/${templateId}`
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async getSoapComponentList() {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}account/template-soap-component-options`
        );

        if (res.data && res.data.response && res.data.response.resources) {
            return res.data.response.resources;
        } else {
            return null;
        }
    },
    async putUpdateLetter(templateId, params) {
        let res = await Axios.put(
            `${baseURL}account/template/letter/${templateId}`,
            params
        );
        if (res.data && res.data.response && res.data.response.resource) {
            return res;
        } else {
            return null;
        }
    },
    async putUpdateSnippet(templateId, params) {
        let res = await Axios.put(
            `${baseURL}account/template/snippet/${templateId}`,
            params
        );
        if (res.data && res.data.response && res.data.response.resource) {
            return res;
        } else {
            return null;
        }
    },
    async putUpdateGeneric(templateId, params) {
        let res = await Axios.put(
            `${baseURL}account/template/save/${templateId}`,
            params
        );
        if (res.data && res.data.response && res.data.response.resource) {
            return res;
        } else {
            return null;
        }
    },
    /* Invoice Bundle Item Section -START- */
    async getItems(templateId) {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}account/template/bundle/get-elements/${templateId}`
        );

        if (res.data && res.data.response && res.data.response.resources) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async updateInvoiceEstimateTemplateItemsOrder(params) {
        return Axios.post(
            `${baseURL}account/template/bundle/reorder/${params.id}`,
            params
        ).then(res => {
            if (res.data) {
                return res.data.response;
            }
            return [];
        });
    },
    /* Invoice Bundle Item Section -END- */
    /* Invoice Bundle Activity Section -START- */
    async getActivities(templateId) {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}/schedule/treatment-template-activities/${templateId}`
        );

        if (res.data && res.data.response && res.data.response.resources) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async updateInvoiceTemplateActivitiesOrder(params) {
        return Axios.post(
            `${baseURL}schedule/treatment-template-activities-reorder/${params.id}`,
            params
        ).then(res => {
            if (res.data) {
                return res.data.response;
            }
            return [];
        });
    },
    async deleteActivity(templateId) {
        let res = await Axios.delete(
            `${process.env.BARRAMUNDI}schedule/treatment-template-activity/${templateId}`
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async saveActivity(params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}schedule/treatment-template-activity`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async updateActivity(activityId, params) {
        let res = await Axios.put(
            `${process.env.BARRAMUNDI}schedule/treatment-template-activity/${activityId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    /* Invoice Bundle Activity Section -END- */
    async getTabCount(templateId) {
        return await Axios.get(
            `${baseURL}account/template/bundle/tab-count/${templateId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    /* Invoice Bundle Action Section -START- */
    async getActions(templateId) {
        return await Axios.get(
            `${baseURL}account/template/bundle/get-actions/${templateId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    async getAction(templateId, actionId) {
        return await Axios.get(
            `${baseURL}account/template/bundle/get-action-by-id/${templateId}?id=${actionId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    async updateInvoiceEstimateTemplateActionsOrder(id, params) {
        return Axios.post(
            `${baseURL}inventory/action/reoder/${id}`,
            params
        ).then(res => {
            if (res.data) {
                return res.data.response;
            }
            return [];
        });
    },
    async deleteAction(templateId, actionId) {
        return await Axios.delete(
            `${baseURL}account/action-template/${templateId}/action/${actionId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    async getActionTypes(templateId) {
        return Axios.get(
            `${baseURL}account/template/bundle/get-actions-type/${templateId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    async addAction(templateId, params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}account/template/bundle/save-actions/${templateId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    /* Invoice Bundle Activity Section -END- */
    async getBundleList(templateId) {
        const res = await Axios.get(
            `${process.env.BARRAMUNDI}account/template/bundle/get-bundle-list/${templateId}`
        );

        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async addBundle(templateId, params) {
        const res = await Axios.post(
            `${process.env.BARRAMUNDI}account/template/bundle/add-bundle/${templateId}`,
            params
        );

        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async getWellnessPlanItems(templateId) {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}account/template/wellness-plan/get-elements/${templateId}`
        );

        if (res.data && res.data.response && res.data.response.resources) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async updateWellnessPlanTemplateItemsOrder(params) {
        return Axios.put(
            `${baseURL}account/template/wellness-plan/reorder-elements/${params.id}`,
            params
        ).then(res => {
            if (res.data) {
                return res.data.response;
            }
            return [];
        });
    },
    async getTabCountWellnessPlan(templateId) {
        return await Axios.get(
            `${baseURL}account/template/wellness-plan/tab-count/${templateId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    async deleteWellnessPlanItem(templateId, params) {
        return Axios.delete(
            `${baseURL}account/template/wellness-plan/remove-element/${templateId}`,
            { params }
        ).then(response => {
            if (response.data && response.data.response) {
                return response.data.response;
            }
            return null;
        });
    },
    async addWellnessPlanItem(templateId, params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}account/template/wellness-plan/save-element/${templateId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async updateWellnessPlanItem(templateId, params) {
        let res = await Axios.put(
            `${process.env.BARRAMUNDI}account/template/wellness-plan/edit-element/${templateId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async getNonPlanDiscounts(templateId) {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}account/template/wellness-plan/get-non-plan/${templateId}`
        );

        if (res.data && res.data.response && res.data.response.resources) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async updateWellnessPlanTemplateNonPlanDiscountsOrder(params) {
        return Axios.put(
            `${baseURL}account/template/wellness-plan/reorder-non-plan/${params.id}`,
            params
        ).then(res => {
            if (res.data) {
                return res.data.response;
            }
            return [];
        });
    },
    async deleteWellnessPlanNonPlanDiscount(templateId, params) {
        return Axios.delete(
            `${baseURL}account/template/wellness-plan/remove-non-plan/${templateId}`,
            { params }
        ).then(response => {
            if (response.data && response.data.response) {
                return response.data.response;
            }
            return null;
        });
    },
    async addWellnessPlanNonDiscount(templateId, params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}account/template/wellness-plan/save-non-plan/${templateId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async updateWellnessPlanNonDiscount(templateId, params) {
        let res = await Axios.put(
            `${process.env.BARRAMUNDI}account/template/wellness-plan/edit-non-plan/${templateId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    }
};
